import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import { definirSessao, recarregarFazendas } from '../sessao';
import PageHeader from '../components/ui/PageHeader';
import Field, { FormRow } from '../components/ui/Field';
import { toast } from '../components/Toast';

/**
 * Entrar em outra fazenda (por código) ou criar uma nova, já logado.
 *
 * O backend identifica a conta pelo email e valida a senha, então pedimos a
 * senha de novo (confirma que é o dono da conta). Entrar por código gera um
 * vínculo PENDENTE (aguarda aprovação do admin daquela fazenda); criar deixa o
 * usuário ADMIN e já ativa a nova fazenda.
 */
export default function GerenciarFazendas({ modo = 'entrar' }) {
  const navigate = useNavigate();
  const criar = modo === 'criar';
  const emailSalvo = ''; // conta logada re-digita o email por segurança
  const [form, setForm] = useState({
    codigoConvite: '',
    nomeFazenda: '',
    cidade: '',
    nome: localStorage.getItem('usuario') || '',
    email: emailSalvo,
    senha: '',
  });
  const [salvando, setSalvando] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const set = (campo) => (e) => setForm((f) => ({ ...f, [campo]: e.target.value }));

  const formatarCodigo = (e) => {
    let v = e.target.value.toUpperCase().replace(/[^A-Z0-9-]/g, '');
    if (v.length > 3 && !v.includes('-')) v = v.slice(0, 3) + '-' + v.slice(3);
    setForm((f) => ({ ...f, codigoConvite: v }));
  };

  const submeter = async (e) => {
    e.preventDefault();
    setSalvando(true);
    try {
      if (criar) {
        const res = await api.criarFazenda({
          nomeFazenda: form.nomeFazenda,
          cidade: form.cidade,
          nome: form.nome,
          email: form.email,
          senha: form.senha,
        });
        // Já ativa a nova fazenda (o backend define fazendaAtivaId nela).
        definirSessao({ fazendas: res.fazendas, fazendaAtivaId: res.fazendaAtivaId });
        toast('Fazenda criada. Você agora está nela.', 'success');
        window.location.assign('/');
      } else {
        await api.entrarComCodigo({
          codigoConvite: form.codigoConvite,
          nome: form.nome,
          email: form.email,
          senha: form.senha,
        });
        // Atualiza a lista para a nova fazenda aparecer como "aguardando".
        await recarregarFazendas().catch(() => {});
        setEnviado(true);
        toast('Solicitação enviada. Aguarde a aprovação do administrador.', 'success');
      }
    } catch (err) {
      toast(err.message || 'Não foi possível concluir.', 'error');
    } finally {
      setSalvando(false);
    }
  };

  if (enviado) {
    return (
      <div>
        <PageHeader titulo="Entrar em outra fazenda" icone="empresa" />
        <div className="card">
          <p>Sua solicitação foi enviada. Assim que o administrador daquela fazenda
            aprovar, ela aparecerá no seletor de fazendas para você acessar.</p>
          <button className="btn-primary" onClick={() => navigate('/')}>Voltar ao início</button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <PageHeader
        titulo={criar ? 'Criar nova fazenda' : 'Entrar em outra fazenda'}
        icone="empresa"
        descricao={criar
          ? 'Você será o administrador desta fazenda, com assinatura e trial próprios.'
          : 'Use o código de convite compartilhado pelo administrador da outra fazenda.'}
      />
      <div className="card">
        <form onSubmit={submeter}>
          {criar ? (
            <FormRow>
              <Field label="Nome da fazenda" obrigatorio>
                <input value={form.nomeFazenda} onChange={set('nomeFazenda')} required placeholder="Ex: Fazenda Boa Vista" />
              </Field>
              <Field label="Cidade">
                <input value={form.cidade} onChange={set('cidade')} placeholder="Cidade / UF" />
              </Field>
            </FormRow>
          ) : (
            <Field label="Código de convite" obrigatorio>
              <input value={form.codigoConvite} onChange={formatarCodigo} required placeholder="AGR-XXXXXX" maxLength={10} />
            </Field>
          )}

          <p className="dica">
            Confirme os dados da sua conta para vincular esta fazenda a ela.
          </p>
          <FormRow>
            <Field label="Seu email" obrigatorio>
              <input type="email" value={form.email} onChange={set('email')} required placeholder="seu@email.com" />
            </Field>
            <Field label="Sua senha" obrigatorio>
              <input type="password" value={form.senha} onChange={set('senha')} required placeholder="Senha da sua conta" />
            </Field>
          </FormRow>

          <div className="actions">
            <button type="button" className="btn-secondary" onClick={() => navigate('/')}>Cancelar</button>
            <button type="submit" className="btn-primary" disabled={salvando}>
              {salvando ? 'Enviando...' : (criar ? 'Criar fazenda' : 'Solicitar acesso')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
